<template>
  <div class="flex flex-direction">
    <div class="search-flex">
      <div class="search-box">
        <el-form ref="form" :model="search" class="flex" label-width="80px">
          <el-form-item label="机构名称">
            <el-input v-model="search.org_name" placeholder="请输入机构名称"></el-input>
          </el-form-item>
        </el-form>
        <div class="search-btn" @click="refreshList">
          <i class="iconfont icon-sousuo"></i>搜索
        </div>
      </div>
    </div>
    <div class="list ">
      <el-table
        :cell-style="textCenter"
        :data="tableData"
        :header-cell-style="centerbgc"
        v-loading="loading"
        border
        style="width: 100%">
        <el-table-column
          label="序号"
          type="index"
          width="80">
        </el-table-column>
        <el-table-column
          label="机构名称"
          prop="org_name"
          width="">
        </el-table-column>
        <el-table-column
          label="宣传标题"
          prop="title"
          width="">
        </el-table-column>
        <el-table-column
          label="提交时间"
          prop="create_time"
          width="200">
        </el-table-column>
        <el-table-column
          label="是否采纳"
          width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="(e)=>{ return handleSwitch(e,scope.row)}"
              :active-value="2"
              :inactive-value="1"
              active-color="#2791ff"
              inactive-color="#999999">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180">
          <template slot-scope="scope" class="flex">
            <el-link type="primary" @click="showDetail(scope.row)">详情</el-link>
            <!--                        <el-link class="margin-left-sm" type="danger">删除</el-link>-->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="page-box">
      <el-pagination
        :current-page.sync="search.page"
        :page-size="search.limit"
        :total="search.total"
        background
        class="page-all margin-top self-end"
        layout="prev, pager, next"
        @current-change="list">
      </el-pagination>
    </div>
    <show-detail-dialog :dialog-visible="showDetailDialog" :id="cur_id" @handleClose="handleClose"></show-detail-dialog>
  </div>
</template>
<script>
import {getPromoteList, promotecai} from "@/api/admin";
import ShowDetailDialog from "@/views/admin/pages/info/promotional/common/showDetailDialog";

export default {
  name: "material",
  data() {
    return {
      search: {
        org_name: '',
        page: 1,
        limit: 10,
        total: 0,
      },
      tableData: [],

      cur_id: '',
      showDetailDialog: false,

      loading: false,
    }
  },
  components: {ShowDetailDialog},
  computed: {
    textCenter() {
      return {
        textAlign: 'center'
      }
    },
    centerbgc() {
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  created() {
    this.$emit("setActive", {
      headActive: 5
    })
    this.list()
  },
  methods: {
    async list() {
      this.loading = true
      let _data = await getPromoteList(
        this.search.org_name,
        this.search.page,
        this.search.limit
      );
      this.loading = false
      if (_data.status == 200) {
        this.tableData = _data.data.data
        this.search.total = _data.data.total
      } else {
        this.$message.error(_data.msg)
      }
    },

    async handleSwitch(e, row) {
      let _data = await promotecai(row.id, e)
      if (_data.status == 200) {
        this.$message.success(_data.msg)
      } else {
        this.$message.error(_data.msg)
      }
    },

    refreshList() {
      this.search.page = 1
      this.list()
    },
    showDetail(item) {
      this.cur_id = item.id
      this.showDetailDialog = true
    },
    handleClose() {
      this.showDetailDialog = false
    }
  },
  watch: {},
  filters: {}
}
</script>

<style lang="scss" scoped>
.list {
  width: 100%;

  .btn {
    width: 60px;
    height: 26px;
    border-radius: 4px;
    font-size: 14px;
    text-align: center;
    line-height: 26px;
    margin: 0 auto;

    &.gray {
      color: #8a8a8a;
      background-color: #f2f2f2;
    }

    &.yellow {
      color: #fad471;
      background-color: #fffbdd;
    }

    &.orange {
      color: #f58739;
      background-color: #ffeedd;
    }

    &.red {
      color: #f8001a;
      background-color: #ffdddd;
    }
  }
}

.search-flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 20px 0;

  .shensu {
    min-width: 113px;
    height: 37px;
    background-image: linear-gradient(0deg,
      #f59a23 0%,
      #feb555 100%);
    border-radius: 4px;
    padding: 0 20px;
    text-align: center;
    line-height: 37px;
    font-size: 16px;
    color: #ffffff;
    cursor: pointer;

    i {
      font-size: 20px;
      margin-right: 5px;
      color: #ffffff;
    }
  }

  .search-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .search-btn {
      width: 112px;
      height: 36px;
      background-image: linear-gradient(0deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 4px;
      text-align: center;
      line-height: 36px;
      font-size: 16px;
      color: #ffffff;
      margin-left: 15px;
      cursor: pointer;

      i {
        font-size: 20px;
        margin-right: 5px;
        color: #ffffff;
      }

      &.reset {
        background-image: none;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #cccccc;
        line-height: 34px;
        color: #333333;

        i {
          color: #999999;
        }
      }
    }
  }

}
</style>


